import { Box } from "@mui/material";
import React from "react";
import { useEffect, useState } from "react";
import { formatDate, formatCurrency, to_vietnamese } from "utils";

const table_style = {
  width: "100%",
  borderCollapse: "collapse",
  minWidth: 1000,
};

const th_td_style = {
  textAlign: "left",
  paddingLeft: 8,
  color: "black",
  fontWeight: "400",
};

const th_td_style_table_product = {
  border: "1px solid black",
  textAlign: "left",
  paddingLeft: 8,
  color: "black",
  fontWeight: "400",
};

export default function TableDN(data) {
  const [value, setValue] = useState(data);
  const [date, setDate] = useState();
  const [listProducts, setListProducts] = useState([]);

  const [totalNoTax, setTotalNoTax] = useState(0);
  const [totalVAT, setTotalVAT] = useState(0);
  const [totalPaymentTax, setTotalPaymentTax] = useState(0);
  const [amountWords, setAmountWords] = useState("Không Đồng");

  useEffect(() => {
    setValue(data);
    handleDate(value.data.day);
    setListProducts(value.data.products);
    handleCal(listProducts);
  }, [data]);

  const handleDate = (day) => {
    const arrDay = formatDate(value.data.day);
    const arrCv = arrDay.split("/");
    const stringDate = "Ngày " + arrCv[0] + " tháng " + arrCv[1] + " năm " + arrCv[2];
    setDate(stringDate);
  };

  const handleCal = (arr) => {
    let totalNoTax = 0;
    let totalVAT = 0;
    let totalPaymentTax = 0;
    if (arr && arr.length > 0) {
      for (const item of arr) {
        const noTax = Number(item.quantity || 0) * Number(item.price || 0);
        totalNoTax += noTax;
        const vat = Number(noTax || 0) * Number(+item.tax / 100 || 0);
        totalVAT += vat;
        totalPaymentTax += Number(noTax) + Number(vat);
      }
    }
    setTotalNoTax(totalNoTax);
    setTotalVAT(totalVAT);
    setTotalPaymentTax(totalPaymentTax);
    setAmountWords(to_vietnamese(totalPaymentTax) + " Đồng");
  };
  return (
    <Box overflow="auto">
      <table
        style={{
          ...table_style,
          borderTop: "1px solid black",
          borderLeft: "1px solid black",
          borderRight: "1px solid black",
        }}
      >
        <tr>
          <th
            style={{
              ...th_td_style,
              fontWeight: "bold",
              fontSize: "30px",
              textAlign: "center",
              padding: 8,
            }}
          >
            HÓA ĐƠN GIÁ TRỊ GIA TĂNG
          </th>
        </tr>
      </table>
      <table
        style={{
          ...table_style,
          borderLeft: "1px solid black",
          borderRight: "1px solid black",
        }}
      >
        <tr>
          <td style={{ ...th_td_style, textAlign: "left", width: 100 }}> </td>
          <td style={{ ...th_td_style, textAlign: "right" }}>Mã hóa đơn:</td>
          <td style={{ ...th_td_style, textAlign: "left", width: 100, color: "red" }}>
            {value?.data?.invoiceSymbol ? value.data.invoiceSymbol : "undefine"}
          </td>
        </tr>
        <tr>
          <td style={{ ...th_td_style, textAlign: "left", width: 100 }}> </td>
          <td style={{ ...th_td_style, textAlign: "right" }}>Số hóa đơn:</td>
          <td style={{ ...th_td_style, textAlign: "left", width: 100 }}>
            {value?.data?.number ? value.data.number : "undefine"}
          </td>
        </tr>
      </table>
      <table
        style={{
          ...table_style,
          borderLeft: "1px solid black",
          borderRight: "1px solid black",
        }}
      >
        <td style={{ ...th_td_style, textAlign: "center" }}>
          {value?.data?.day ? date : "undefine"}
        </td>
      </table>
      <table
        style={{
          ...table_style,
          borderLeft: "1px solid black",
          borderRight: "1px solid black",
        }}
      >
        <tr>
          <td style={{ ...th_td_style, textAlign: "left", width: 150 }}>Tên người bán:</td>
          <td style={{ ...th_td_style, textAlign: "left", fontWeight: "bold", fontSize: "20px" }}>
            {value?.data?.sellerName ? value.data.sellerName : "undefine"}
          </td>
          <td style={{ ...th_td_style, textAlign: "left", width: 100 }}> </td>
        </tr>
        <tr>
          <td style={{ ...th_td_style, textAlign: "left", width: 150 }}>Mã số thuế:</td>
          <td style={{ ...th_td_style, textAlign: "left" }}>
            {value?.data?.sellerTaxCode ? value.data.sellerTaxCode : ""}
          </td>
          <td style={{ ...th_td_style, textAlign: "left", width: 100 }}> </td>
        </tr>
        <tr>
          <td style={{ ...th_td_style, textAlign: "left", width: 150 }}>Địa chỉ:</td>
          <td style={{ ...th_td_style, textAlign: "left" }}>
            {value?.data?.sellerAddress ? value.data.sellerAddress : ""}
          </td>
          <td style={{ ...th_td_style, textAlign: "left", width: 100 }}> </td>
        </tr>
        <tr>
          <td style={{ ...th_td_style, textAlign: "left", width: 150 }}>Điện thoại:</td>
          <td style={{ ...th_td_style, textAlign: "left" }}>
            {value?.data?.sellerPhone ? value.data.sellerPhone : ""}
          </td>
          <td style={{ ...th_td_style, textAlign: "left", width: 100 }}> </td>
        </tr>
        <tr>
          <td style={{ ...th_td_style, textAlign: "left", width: 250 }}>Số tài khoản:</td>
          <td style={{ ...th_td_style, textAlign: "left" }}>
            {value?.data?.sellerBankAccount ? value.data.sellerBankAccount : ""}
          </td>
          <td style={{ ...th_td_style, textAlign: "left", width: 100 }}> </td>
        </tr>
        <tr style={{ borderTop: "1px solid black" }}>
          <td
            style={{ ...th_td_style, textAlign: "left", width: 150, borderTop: "1px solid black" }}
          >
            Tên người mua:
          </td>
          <td style={{ ...th_td_style, textAlign: "left", fontWeight: "bold", fontSize: "20px" }}>
            {value?.data?.buyerName ? value.data.buyerName : ""}
          </td>
          <td style={{ ...th_td_style, textAlign: "left", width: 100 }}> </td>
        </tr>
        <tr>
          <td style={{ ...th_td_style, textAlign: "left", width: 150 }}>Mã số thuế:</td>
          <td style={{ ...th_td_style, textAlign: "left" }}>
            {value?.data?.buyerTaxCode ? value.data.buyerTaxCode : ""}
          </td>
          <td style={{ ...th_td_style, textAlign: "left", width: 100 }}> </td>
        </tr>
        <tr>
          <td style={{ ...th_td_style, textAlign: "left", width: 150 }}>Địa chỉ:</td>
          <td style={{ ...th_td_style, textAlign: "left" }}>
            {value?.data?.buyerAddress ? value.data.buyerAddress : ""}
          </td>
          <td style={{ ...th_td_style, textAlign: "left", width: 100 }}> </td>
        </tr>
        <tr>
          <td style={{ ...th_td_style, textAlign: "left", width: 250 }}>Hình thức thanh toán:</td>
          <td style={{ ...th_td_style, textAlign: "left" }}>
            {value?.data?.payments
              ? value.data.payments === "cash"
                ? "Tiền mặt"
                : "Chuyển khoản"
              : ""}
          </td>
          <td style={{ ...th_td_style, textAlign: "left", width: 100 }}> </td>
        </tr>
        <tr>
          <td style={{ ...th_td_style, textAlign: "left", width: 250 }}>Số tài khoản:</td>
          <td style={{ ...th_td_style, textAlign: "left" }}>
            {value?.data?.buyerBankAccount ? value.data.buyerBankAccount : ""}
          </td>
          <td style={{ ...th_td_style, textAlign: "left", width: 100 }}> </td>
        </tr>
        <tr>
          <td style={{ ...th_td_style, textAlign: "left", width: 250 }}>Đồng tiền thanh toán:</td>
          <td style={{ ...th_td_style, textAlign: "left" }}>
            {value?.data?.currency ? value.data.currency : ""}
          </td>
          <td style={{ ...th_td_style, textAlign: "left", width: 100 }}> </td>
        </tr>
      </table>
      <table
        style={{
          ...table_style,
          borderLeft: "1px solid black",
          borderRight: "1px solid black",
        }}
      >
        <tr>
          <th style={{ ...th_td_style_table_product, textAlign: "center", padding: 8 }}>STT</th>
          <th style={{ ...th_td_style_table_product, textAlign: "center", padding: 8 }}>
            Tên hàng hóa, dịch vụ
          </th>
          <th style={{ ...th_td_style_table_product, textAlign: "center", padding: 8 }}>
            Đơn vị tính
          </th>
          <th style={{ ...th_td_style_table_product, textAlign: "center", padding: 8 }}>
            Số lượng
          </th>
          <th style={{ ...th_td_style_table_product, textAlign: "center", padding: 8 }}>Đơn giá</th>
          <th style={{ ...th_td_style_table_product, textAlign: "center", padding: 8 }}>
            Thuế suất
          </th>
          <th style={{ ...th_td_style_table_product, textAlign: "center", padding: 8 }}>
            Thành tiền chưa có thuế GTGT
          </th>
          <th style={{ ...th_td_style_table_product, textAlign: "center", padding: 8 }}>
            Tiền thuế GTGT
          </th>
          <th style={{ ...th_td_style_table_product, textAlign: "center", padding: 8 }}>
            Thành tiền có thuế GTGT
          </th>
        </tr>
        <tr>
          <th style={{ ...th_td_style_table_product, textAlign: "center", padding: 8 }}>0</th>
          <th style={{ ...th_td_style_table_product, textAlign: "center", padding: 8 }}>2</th>
          <th style={{ ...th_td_style_table_product, textAlign: "center", padding: 8 }}>3</th>
          <th style={{ ...th_td_style_table_product, textAlign: "center", padding: 8 }}>4</th>
          <th style={{ ...th_td_style_table_product, textAlign: "center", padding: 8 }}>5</th>
          <th style={{ ...th_td_style_table_product, textAlign: "center", padding: 8 }}>6</th>
          <th style={{ ...th_td_style_table_product, textAlign: "center", padding: 8 }}>
            7 = 4 x 5
          </th>
          <th style={{ ...th_td_style_table_product, textAlign: "center", padding: 8 }}>
            8 = 7 x 6
          </th>
          <th style={{ ...th_td_style_table_product, textAlign: "center", padding: 8 }}>
            9 = 7 + 8
          </th>
        </tr>
        {listProducts &&
          listProducts.length > 0 &&
          listProducts.map((row, index) => {
            return (
              <tr key={index}>
                <th style={{ ...th_td_style_table_product, textAlign: "center", padding: 8 }}>
                  {++index}
                </th>
                <th style={{ ...th_td_style_table_product, textAlign: "center", padding: 8 }}>
                  {row?.name}
                </th>
                <th style={{ ...th_td_style_table_product, textAlign: "center", padding: 8 }}>
                  {row?.unit}
                </th>
                <th style={{ ...th_td_style_table_product, textAlign: "center", padding: 8 }}>
                  {row?.quantity}
                </th>
                <th style={{ ...th_td_style_table_product, textAlign: "center", padding: 8 }}>
                  {formatCurrency.format(row?.price)}
                </th>
                <th style={{ ...th_td_style_table_product, textAlign: "center", padding: 8 }}>
                  {row?.tax + "%"}
                </th>
                <th style={{ ...th_td_style_table_product, textAlign: "center", padding: 8 }}>
                  {formatCurrency.format(Number(row?.quantity) * Number(row?.price))}
                </th>
                <th style={{ ...th_td_style_table_product, textAlign: "center", padding: 8 }}>
                  {formatCurrency.format(
                    (Number(row?.quantity) * Number(row?.price) * Number(row?.tax)) / 100
                  )}
                </th>
                <th style={{ ...th_td_style_table_product, textAlign: "center", padding: 8 }}>
                  {formatCurrency.format(
                    (Number(row?.quantity) * Number(row?.price) * Number(row?.tax)) / 100 +
                      Number(row?.quantity) * Number(row?.price)
                  )}
                </th>
              </tr>
            );
          })}
      </table>
      <table
        style={{
          ...table_style,
          borderLeft: "1px solid black",
          borderRight: "1px solid black",
        }}
      >
        <tr>
          <th style={{ ...th_td_style, textAlign: "left", padding: 8, width: 300 }}>
            Tổng tiền chưa có thuế GTGT:
          </th>
          <th style={{ ...th_td_style, textAlign: "left", padding: 8 }}>
            {formatCurrency.format(totalNoTax)}
          </th>
        </tr>
        <tr>
          <th style={{ ...th_td_style, textAlign: "left", padding: 8, width: 450 }}>
            Tổng tiền thuế GTGT theo từng loại thuế suất:
          </th>
          <th style={{ ...th_td_style, textAlign: "left", padding: 8 }}>
            {formatCurrency.format(totalVAT)}
          </th>
        </tr>
        <tr>
          <th style={{ ...th_td_style, textAlign: "left", padding: 8, width: 370 }}>
            Tổng tiền thanh toán đã có thuế GTGT:
          </th>
          <th style={{ ...th_td_style, textAlign: "left", padding: 8 }}>
            {formatCurrency.format(totalPaymentTax)}
          </th>
        </tr>
        <tr>
          <th style={{ ...th_td_style, textAlign: "left", padding: 8, width: 370 }}>
            Số tiền viết bằng chữ:
          </th>
          <th style={{ ...th_td_style, textAlign: "left", padding: 8 }}>{amountWords}</th>
        </tr>
      </table>
      <table
        style={{
          ...table_style,
          border: "1px solid black",
          borderLeft: "1px solid black",
          borderRight: "1px solid black",
          borderBottom: "1px solid black",
        }}
      >
        <tr>
          <th style={{ ...th_td_style, textAlign: "center", padding: 8, width: 370 }}>
            Người mua hàng
          </th>
          <th style={{ ...th_td_style, textAlign: "center", padding: 8, width: 370 }}>
            Người bán hàng
          </th>
        </tr>
        <tr>
          <th style={{ ...th_td_style, textAlign: "center", width: 370 }}>
            {"(Chữ ký số (nếu có))"}
          </th>
          <th style={{ ...th_td_style, textAlign: "center", width: 370 }}>
            {"(Chữ điện tử, Chữ ký số)"}
          </th>
        </tr>
        <tr>
          <th style={{ ...th_td_style, textAlign: "center", padding: 8, width: 370, height: 100 }}>
            {""}
          </th>
          <th style={{ ...th_td_style, textAlign: "center", padding: 8, width: 370, height: 100 }}>
            {""}
          </th>
        </tr>
      </table>
    </Box>
  );
}
